export class Token {

    creation_timestamp:number;


    getAutorization() {
        return this.grant_type + " " + this.access_token;
    }

    constructor(public access_token : string,public  refresh_token: string,public expires_in : number, public grant_type : string= "client") {
    }


    isExpired() {
        
        let current_time = Date.now();
        if (this.expires_in < current_time) {
            return true;
        }
        return false;
    }
}